import { Component, Injector, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import { AppComponent } from '../../../app/app.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicCatalogFormComponent } from './dynamiccatalog-form.component';

@Component({
    templateUrl: './dynamiccatalog-form-modal.component.html'
})
export class DynamicCatalogFormModalComponent extends AppComponentBase implements OnInit {

    @ViewChild('cform', { static: false }) cform: DynamicCatalogFormComponent;

    tabla: string;
    id?: number = null;
    permisos: any;
    registrosCreados = 0;

    saving = false;

    constructor(
        injector: Injector,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig
    ) {
        super(injector);
    }

    ngOnInit() {
        const self = this;

        self.tabla = self.modalConfig.data.tabla;
        self.id = self.modalConfig.data.id;
        self.permisos = self.modalConfig.data.permisos;
    }

    ngAfterInit() {
        const self = this;

    }

    save(): void {
        const self = this;

        self.saving = true;
        self.cform.save();
    }

    afterSaved(event): void {
        const self = this;

        self.saving = false;

        if (event) {
            if (self.id) {
                self.close(true);
            } else {
                self.registrosCreados++;
            }
        }
    }

    doClose(): void {
        const self = this;

        // alert(self.registrosCreados > 0);
        self.close(self.registrosCreados > 0);
    }

    close(isSaved: boolean): void {
        const self = this;
        self.modalRef.close(isSaved);
    }
}
